import {
  ListItem as ListItemMui,
  ListItemProps as ListItemPropsMui,
} from '@mui/material';

export type ListItemProps = ListItemPropsMui;

export function ListItem({ ...rest }: ListItemProps) {
  return <ListItemMui {...rest} />;
}
